import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class FooterTagline {
    static init(e) {
        const tagline = e.detail.element.querySelector('[data-footer-tagline]');
        new FooterTagline(tagline);
    }

    constructor(tagline) {
        if(!tagline) {
            return;
        }

        this.tagline = tagline;

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.tagline,
                start: "top bottom",
            }
        });
        tl.to(this.tagline, {
            x: 0,
            duration: 2,
            ease: "power2.inOut"
        });

    }
}
